import { ReactElement, useState, useEffect } from 'react';
import EnhetsgrupperingApi from 'services/KjederegisteretAdminApi/EnhetsgrupperingApi';

export const EnhetsgrupperingPath = (props: { nr: string }): ReactElement => {
  const [leftInnkjopPath, setLeftInnkjopPath] = useState<string[]>([]);

  const loadEnhetsgruppePath = async (enhetsgrupperingNr: string) => {
    const innkjopsResponse =
      await EnhetsgrupperingApi.getEnhetsgrupperingNavnHierarkiByNr(enhetsgrupperingNr);
    setLeftInnkjopPath(innkjopsResponse?.map((o) => o.enhetsgrupperingnavn).toReversed());
  };

  // fetch full enhetsgruppe path for the suggested innkjøp
  useEffect(() => {
    if (props.nr) {
      loadEnhetsgruppePath(props.nr);
    }
  }, [props.nr]);
  return (
    <span>
      {leftInnkjopPath.join(' / ')} ({props.nr})
    </span>
  );
};
